// Aufklappfenster unter einem Auslöser (Handoff Rechnungen §4: Objekt, Haus, Filter, Zuständigkeit …):
// Fläche --sheet, Radius 20, Schatten, kurz einblenden. Öffnen/Schließen (Klick außerhalb, Esc) regelt der Aufrufer,
// der Auslöser und Panel in einem gemeinsamen Container mit ref hält.
import type { CSSProperties, ReactNode } from 'react';

export interface DropdownPanelProps {
  children: ReactNode;
  /** an welcher Kante des Auslösers ausrichten */
  ausrichtung?: 'links' | 'rechts';
  breite?: number;
  /** Abstand nach oben (Höhe des Auslösers + Luft) */
  oben?: number;
  label?: string;
  rolle?: 'dialog' | 'menu' | 'listbox';
  style?: CSSProperties;
}

export function DropdownPanel({ children, ausrichtung = 'links', breite = 320, oben = 50, label, rolle = 'dialog', style }: DropdownPanelProps) {
  return (
    <div role={rolle} aria-label={label}
      className="immo-pop-in absolute flex flex-col"
      style={{ top: oben, [ausrichtung === 'links' ? 'left' : 'right']: 0, width: breite, maxWidth: 'calc(100vw - 24px)', zIndex: 40,
        borderRadius: 20, padding: 10, gap: 6, background: 'var(--sheet)', color: 'var(--ink)',
        boxShadow: '0 24px 50px -16px var(--shade), inset 0 0 0 1px var(--line)', ...style }}>
      {children}
    </div>
  );
}

/** Zeile in einem Aufklappfenster (Titel + optionale Unterzeile); gewählt = Akzentfläche. */
export function DropdownZeile({ titel, unter, gewaehlt = false, onClick, fett = false, icon }: {
  titel: ReactNode; unter?: ReactNode; gewaehlt?: boolean; onClick: () => void; fett?: boolean; icon?: ReactNode;
}) {
  return (
    <button type="button" onClick={onClick} aria-pressed={gewaehlt}
      className="immo-zeile-hover flex w-full min-w-0 items-center text-left"
      style={{ gap: 8, minHeight: 40, padding: '8px 12px', border: 'none', borderRadius: 12, cursor: 'pointer', fontFamily: 'inherit', color: 'var(--ink)',
        background: gewaehlt ? 'var(--acc-soft)' : 'transparent' }}>
      {icon}
      <span className="flex min-w-0 flex-1 flex-col" style={{ gap: 1 }}>
        <span className="truncate" style={{ fontSize: 13, fontWeight: fett ? 800 : 700, color: gewaehlt ? 'var(--acc)' : 'var(--ink)' }}>{titel}</span>
        {unter && <span className="truncate" style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--ink3)' }}>{unter}</span>}
      </span>
    </button>
  );
}
